import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FeatureGuardService } from './feature-guard.service';
import { FeatureToggleDirective } from './feature-toggle.directive';
import { FeatureService } from './feature.service';
import { MaintenanceStrategyToggleDirective } from './maintenance-strategy-toggle.directive';
import { ModelCloneToggleDirective } from './model-clone-feature-toggle.directive';
@NgModule({
  declarations: [FeatureToggleDirective, ModelCloneToggleDirective, MaintenanceStrategyToggleDirective],
  exports: [FeatureToggleDirective, ModelCloneToggleDirective, MaintenanceStrategyToggleDirective],
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [FeatureGuardService, FeatureService],
})
export class FeaturesModule { }
